'use client';

import { Info } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { Badge, type BadgeSize } from '@//components/Badge';
import { IconButton } from '@//components/IconButton';
import { Modal } from '@//components/Modal';
import { TextContent } from '@//components/TextContent';
import styles from './DemoVehicleBadge.module.scss';

interface DemoVehicleBadgeProps {
  size?: BadgeSize;
  testId?: string;
}

export const DemoVehicleBadge: React.FC<DemoVehicleBadgeProps> = ({ size, testId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const t = useTranslations('utils.vehicleGlossary.demoVehicle');

  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  return (
    <>
      <Badge size={size} tone="info">
        {t('label')}
        <IconButton
          label={t('modal.title')}
          size="xs"
          variant="no-bg"
          onClick={handleOpenModal}
          testId={testId}
          className={styles.infoButton}
        >
          <Info size={14} aria-hidden="true" />
        </IconButton>
      </Badge>
      <Modal
        title={t('modal.title')}
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        testId={testId ? `${testId}-modal` : undefined}
      >
        <TextContent textSize="md">
          <p>{t('modal.content')}</p>
        </TextContent>
      </Modal>
    </>
  );
};
